module.exports = __webpack_public_path__ + "img/FR11307.c53de322.png";